"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlurredIconTile = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* istanbul ignore file -- remove once added tests */
const clsx_1 = __importDefault(require("clsx"));
const BlurredIconTile_module_css_1 = __importDefault(require("./BlurredIconTile.module.css"));
/**
 * Default blurred icon previews for lenses with no media
 * Figma: https://www.figma.com/file/Y23FWNw5KRAMrxoRgpqPM2/Lens-Explorer?node-id=4681%3A30491
 */
function BlurredIconTile({ iconUrl, size = "small", hideIconOverlay, iconBorder, alt, children, }) {
    const containerStyles = (0, clsx_1.default)([BlurredIconTile_module_css_1.default.container], {
        [BlurredIconTile_module_css_1.default.containerLarge]: size === "large",
    });
    function getImage(style) {
        return (0, jsx_runtime_1.jsx)("img", { className: style, src: iconUrl, alt: alt });
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: containerStyles, children: [(0, jsx_runtime_1.jsx)("div", { className: BlurredIconTile_module_css_1.default.blurredImageContainer, children: getImage(BlurredIconTile_module_css_1.default.blurredImage) }), !hideIconOverlay && ((0, jsx_runtime_1.jsx)("div", { className: BlurredIconTile_module_css_1.default.iconContainer, children: iconBorder ? ((0, jsx_runtime_1.jsx)("div", { className: BlurredIconTile_module_css_1.default.iconRadiusContainer, children: getImage(BlurredIconTile_module_css_1.default.iconRadius) })) : (getImage(BlurredIconTile_module_css_1.default.icon)) })), children] }));
}
exports.BlurredIconTile = BlurredIconTile;
//# sourceMappingURL=BlurredIconTile.js.map